import React, { useState } from 'react';
import DataTableCard from '../../../../components/ui/DataTableCard';
import { useFetchList } from '../../../../hooks/useFetchList';
import { dateTimeBody } from '../../../../utils/tableTemplates';
import ChangeStatusCooperateReceiptDialog from '../../components/cooperate_receipts/ChangeStatusCooperateReceiptDialog';

const STATUS_STYLES = {
    PENDING: {color: '#FCB700', backgroundColor: '#FFF8E1'},
    RECEIPTED: {color: '#00BAFE', backgroundColor: '#E6F7FF'},
    COMPLETED: {color: '#00D390', backgroundColor: '#E6FFF7'},
    'REVOKE REQUESTED': {color: '#6C5CE7', backgroundColor: '#F3EFFF'},
    FAILED: {color: '#FF6266', backgroundColor: '#FFECEC'},
    REVOKED: {color: '#FF6266', backgroundColor: '#FFECEC'},
};
const DEFAULT_STATUS_STYLE = {color: '#A0A0A0', backgroundColor: '#F5F5F5'};

const amountBodyTemplate = (rowData) =>
    `${rowData.currency || ''} ${Number.parseFloat(rowData.amount || 0).toFixed(2)}`;

const statusBodyTemplate = (rowData) => (
    <span
        style={{
            ...(STATUS_STYLES[rowData.status] ?? DEFAULT_STATUS_STYLE),
            padding: '0.25rem 0.5rem',
            borderRadius: '4px',
            fontWeight: 'bold',
            fontSize: '0.85rem'
        }}
    >
        {rowData.status}
    </span>
);

const paymentModeBodyTemplate = (rowData) => {
    const mode = rowData.modeOfPayment;
    if (!mode) return null;
    return <span className="badge badge-outline text-sm">{mode.toString().toUpperCase().replaceAll("CR_", "")}</span>;
};

const AllCorporateReceiptsTable = () => {
    const {rows: receipts, setRows: setReceipts, loading} = useFetchList('cooperateReceipt/all');
    const [selectedReceipt, setSelectedReceipt] = useState(null);

    const handleStatusUpdate = (receiptNumber, newStatus) => {
        setReceipts(prevReceipts =>
            prevReceipts.map(receipt =>
                receipt.receiptNumber === receiptNumber ? {...receipt, status: newStatus} : receipt
            )
        );
    };

    const actionBodyTemplate = (rowData) => (
        <div className="actions-container flex items-center justify-center gap-2">
            <div className="tooltip" data-tip="Change Status">
                <button
                    className="btn btn-sm btn-circle btn-ghost text-base-content/70 hover:text-base-content hover:bg-base-200"
                    onClick={() => setSelectedReceipt(rowData)}
                >
                    <i className="pi pi-pencil text-lg"></i>
                </button>
            </div>
        </div>
    );

    const columns = [
        {field: 'receiptNumber', header: 'Receipt Number', sortable: true},
        {field: 'cooperateName', header: 'Corporate Name', sortable: true},
        {field: 'modeOfPayment', header: 'Payment Mode', body: paymentModeBodyTemplate, sortable: true},
        {field: 'agentName', header: 'Agent Name', sortable: true},
        {field: 'amount', header: 'Amount', body: amountBodyTemplate, sortable: true},
        {field: 'status', header: 'Status', body: statusBodyTemplate, sortable: true},
        {field: 'createdAt', header: 'Created At', body: dateTimeBody('createdAt'), sortable: true},
        {field: 'revokedAt', header: 'Revoked At', body: dateTimeBody('revokedAt'), sortable: true},
        {field: 'actions', header: 'Actions', body: actionBodyTemplate, style: {textAlign: 'center'}},
    ];

    return (
        <>
            <DataTableCard
                title="All Corporate Receipts Report"
                exportName="Corporate Receipts"
                columns={columns}
                rows={receipts}
                loading={loading}
                rowsPerPage={10}
                rowsPerPageOptions={[5, 10, 25, 50, 100]}
                emptyMessage="No corporate receipts found"
                searchPlaceholder="Search receipts..."
                csvOnly
                exportDisabled={false}
            />

            <ChangeStatusCooperateReceiptDialog
                visible={selectedReceipt !== null}
                receipt={selectedReceipt}
                onHide={() => setSelectedReceipt(null)}
                onStatusUpdate={handleStatusUpdate}
            />
        </>
    );
};

export default AllCorporateReceiptsTable;
